
import React, { useState, useEffect } from 'react';
import MainLayout from '../layouts/MainLayout';
import { Helmet } from 'react-helmet';
import CategoryToggle from '../components/portfolio/CategoryToggle';
import PortfolioList from '../components/portfolio/PortfolioList';
import { photoItems, filmItems } from '../components/portfolio/portfolioData';

const PortfolioPage = () => {
  const [activeCategory, setActiveCategory] = useState<'photos' | 'films'>('photos');
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const getPortfolioItems = () => {
    switch (activeCategory) {
      case 'photos':
        return photoItems;
      case 'films':
        return filmItems;
      default:
        return photoItems;
    }
  };
  
  return (
    <MainLayout>
      <Helmet>
        <title>Portfolio | Czułe Klisze</title>
        <meta name="description" content="Zobacz nasze realizacje - fotografia i film. Czułe Klisze to profesjonalne studio fotograficzne i filmowe." />
        <meta property="og:title" content="Portfolio | Czułe Klisze" />
        <meta property="og:description" content="Zobacz nasze realizacje - fotografia i film." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://czuleklisze.pl/portfolio" />
        <link rel="canonical" href="https://czuleklisze.pl/portfolio" />
      </Helmet>
      
      <div className="pt-32 md:pt-40 pb-6 bg-white">
        <div className="container-custom">
          <div className="text-center max-w-2xl mx-auto">
            <h1 className="text-3xl md:text-4xl font-serif text-elegant-900 mb-4 tracking-tight">Nasze Portfolio</h1>
            <p className="text-elegant-600 mb-8 max-w-xl mx-auto font-inter font-light uppercase tracking-wide text-sm">
              Najpiękniejsze historie, które mieliśmy przyjemność uwiecznić.
            </p>
          </div>
        </div>
      </div>
      
      <div className="pb-20 bg-elegant-50">
        <div className="container-custom">
          <CategoryToggle activeCategory={activeCategory} setActiveCategory={setActiveCategory} />
          <PortfolioList items={getPortfolioItems()} isMobile={isMobile} activeCategory={activeCategory} />
        </div>
      </div>
    </MainLayout>
  );
};

export default PortfolioPage;
